module.exports = __webpack_public_path__ + "img/20200421141141TIM截图20200421140130.ee6a3bc3.png";